import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import LiveLayout from "./LiveLayout";
import D13Footer from "../preview/D13Footer";
import { Star } from "./Star";
import { FAQ_ITEMS, SITE_UPDATED } from "../../lib/adelContent";
import "./Editorial.css";

/* /faq — answer-first Q&A hub for jobseekers + employers. The FAQPage JSON-LD is
   emitted by PageSEO from the same FAQ_ITEMS, so the questions are machine-readable
   for AI answer engines (the highest-value AEO asset in this niche). */
export default function FAQPage() {
  const groups = [
    { key: "candidate", title: "For jobseekers" },
    { key: "employer", title: "For employers" },
  ];
  // Answers are plain strings (they also feed the FAQPage JSON-LD). When an item has an
  // inlineLink, render that phrase inside the answer as an internal Link.
  const renderAnswer = (f) => {
    if (!f.inlineLink) return f.a;
    const i = f.a.indexOf(f.inlineLink.text);
    if (i === -1) return f.a;
    return (
      <>
        {f.a.slice(0, i)}
        <Link to={f.inlineLink.to} className="faq-a-link">{f.inlineLink.text}</Link>
        {f.a.slice(i + f.inlineLink.text.length)}
      </>
    );
  };
  return (
    <LiveLayout audience="candidate">
      <header className="ed-band ed-band--cream spoke-head">
        <div className="ed-container">
          <span className="ed-eyebrow spoke-head__eyebrow"><Star className="ed-eyebrow__star" /> Questions &amp; answers</span>
          <h1 className="spoke-title">Answers, <em>in plain words.</em></h1>
          <p className="ed-lede spoke-intro">
            Straight answers for jobseekers and employers — fees, licensing, timelines,
            and how working with Adel Group actually works.
          </p>
          <p className="ed-stamp">Last updated {SITE_UPDATED}</p>
        </div>
      </header>

      {groups.map((g, gi) => (
        <section key={g.key} className={`ed-band ${gi % 2 === 0 ? "ed-band--sand" : "ed-band--cream"} ed-pad`}>
          <div className="ed-container">
            <span className="ed-eyebrow"><Star className="ed-eyebrow__star" /> {g.title}</span>
            <div className="faq-list">
              {FAQ_ITEMS.filter((f) => f.audience === g.key).map((f) => (
                <div key={f.q} className="faq-item">
                  <h3 className="faq-q">{f.q}</h3>
                  <p className="faq-a">{renderAnswer(f)}</p>
                  {f.link && (
                    <p className="faq-a faq-verify">
                      <a href={f.link.href} target="_blank" rel="noreferrer">{f.link.label} →</a>
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      <section className="ed-band ed-band--ink ed-pad">
        <div className="ed-container ed-cta">
          <h2 className="ed-cta__t">Still have a question? Talk to a real person.</h2>
          <div className="ed-cta__row">
            <Link to="/candidates/apply" className="d13-btn d13-btn--primary">Submit your CV <ArrowRight size={16} strokeWidth={2.2} /></Link>
            <Link to="/employers/brief" className="d13-btn d13-btn--ghost">Request workers</Link>
          </div>
        </div>
      </section>

      <D13Footer />
    </LiveLayout>
  );
}
